
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"width":"6","height":"16","x":"4","y":"21","stroke":"#A4A8C0","stroke-width":"1.25","rx":"2","transform":"rotate(-90 4 21)"}}),_c('rect',{attrs:{"width":"20","height":"1","x":"2","y":"12","fill":"#A4A8C0","rx":".5"}}),_c('rect',{attrs:{"width":"6","height":"16","x":"4","y":"10","stroke":"#A4A8C0","stroke-width":"1.25","rx":"2","transform":"rotate(-90 4 10)"}})])
          )
        }
      }
    